<div class="report-container" id="cloud-readiness-report" *ngIf="answers?.answers">

  <div class="export-pdf-button">
    <button mat-raised-button color="primary" (click)="exportFullPageToPDF()">
      Export to PDF
    </button>
  </div>


  <div class="report-container-content"> 
    <div class="chart-and-heatmap">
      <h2>Cloud Readiness Radar Chart</h2>
      <div class="chart-container">
        <div echarts [options]="chartOption" class="radar-chart"></div>
      </div>

      
      <h2>Cloud Readiness Heatmap</h2>
      <div class="heatmap-container">
        <div
          *ngFor="let section of sectionKeys"
          class="section-card mat-elevation-z4"
        >
          <h3 class="heatmap-title">
            <!-- <span class="icon">{{ sectionTitles[section].icon }}</span>
            {{ sectionTitles[section].label }} -->
            {{section}} Section
          </h3>

          <div class="item-list">
            <div
              *ngFor="let item of answers.answers[section]"
              class="item-row"
              [ngClass]="getColorClass(item.rating)"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <h2>Assessment Summary</h2>
    <div class="assessment-summary-container mat-elevation-z4">
      <ng-container *ngFor="let section of sectionKeys">
        <h2 class="section-title">
          <!-- <mat-icon color="warn">warning</mat-icon> -->
          {{ section }} Section
        </h2>
        <div class="content-grid">
          <!-- LEFT COLUMN: Questions & Ratings -->
          <div class="left-column">
            <div *ngFor="let item of answers.answers[section]" class="question-card">
              <h3>{{ item.title }}</h3>
              <p><strong>Question:</strong> {{ item.question }}</p>
              <p><strong>Response:</strong> {{ item.response }}</p>
              <mat-progress-bar
                mode="determinate"
                [value]="item.rating * 20"
                [ngClass]="item.rating >= 4 ? 'progress-green' : 'progress-orange'"
              ></mat-progress-bar>
              <p class="rating">Rating: {{ item.rating }}</p>
            </div>
          </div>
          <!-- RIGHT COLUMN: Recommended Actions -->
          <div class="right-column">
            <h3 class="actions-header">Recommended Actions</h3>
            <div *ngFor="let recommendedAction of getRecommendedActions(section)" class="action-group">
              <h4>{{ recommendedAction?.title }}</h4>
              <ul>
                <li *ngFor="let act of recommendedAction.recommendations" [innerHTML]="sanitizeHtml(act)"></li>
              </ul>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<nio-spinner *ngIf="loading"></nio-spinner>